import { render, staticRenderFns } from "./modalEditSocialXp.vue?vue&type=template&id=67da363d&"
import script from "./modalEditSocialXp.vue?vue&type=script&lang=js&"
export * from "./modalEditSocialXp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports